"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormattedFloatingPoint = void 0;
var tslib_1 = require("tslib");
var isEqual_1 = (0, tslib_1.__importDefault)(require("lodash/fp/isEqual"));
var cond_1 = (0, tslib_1.__importDefault)(require("lodash/fp/cond"));
var stubTrue_1 = (0, tslib_1.__importDefault)(require("lodash/fp/stubTrue"));
var toFixedDecimalPlace = function (value, totalLength) {
    return value.toFixed(totalLength);
};
var allPurposeFormatter = function (value, style, minimumFractionDigits, maximumFractionDigits, useGrouping) {
    return new Intl.NumberFormat('default', {
        style: style,
        minimumFractionDigits: minimumFractionDigits,
        maximumFractionDigits: maximumFractionDigits,
        useGrouping: useGrouping,
    }).format(value);
};
var currencyFormatter = function (value) {
    return new Intl.NumberFormat('default', {
        style: 'currency',
        currency: 'USD',
        currencyDisplay: 'symbol',
    }).format(value);
};
var w12LeadingZeros = function (value) {
    var valueString = value.toString();
    var valueLength = valueString.length;
    var isInteger = Number.isInteger(value);
    if (valueString.length < 13) {
        if (isInteger) {
            var formattedValue_1 = Number.parseFloat(valueString).toPrecision(12);
            return formattedValue_1;
        }
        var formattedValue_2 = Number.parseFloat(valueString).toPrecision(12);
        return formattedValue_2;
    }
    if (isInteger) {
        var formattedValue_3 = Number.parseFloat(valueString).toPrecision(valueLength);
        return formattedValue_3;
    }
    if (valueLength === 13) {
        var formattedValue_4 = Number.parseFloat(valueString).toPrecision(12);
        return formattedValue_4;
    }
    var formattedValue = Number.parseFloat(valueString).toFixed();
    return formattedValue;
};
var w12NoZeros = function (value) {
    var valueString = value.toString();
    var valueLength = valueString.length;
    var isInteger = Number.isInteger(value);
    if (valueLength <= 13) {
        if (isInteger) {
            var formattedValue_5 = Number.parseFloat(valueString).toPrecision(valueLength);
            return formattedValue_5;
        }
        var formattedValue_6 = Number.parseFloat(valueString).toPrecision(valueLength - 1);
        return formattedValue_6;
    }
    if (isInteger) {
        var formattedValue_7 = Number.parseFloat(valueString).toPrecision(valueLength);
        return formattedValue_7;
    }
    var formattedValue = Number.parseFloat(valueString).toPrecision(12);
    return formattedValue;
};
var G4 = function (value) {
    var stringValue = value.toString();
    var valueLength = stringValue.length;
    var isInteger = Number.isInteger(value);
    if (isInteger) {
        if (valueLength <= 4) {
            var formattedValue_8 = Number.parseFloat(stringValue).toFixed();
            return formattedValue_8;
        }
        var formattedValue_9 = Number.parseFloat(stringValue)
            .toExponential(4)
            .toUpperCase();
        return formattedValue_9;
    }
    var integerValue = stringValue.split('.')[0];
    if (integerValue.length < 4) {
        if (valueLength < 5) {
            var formattedValue_10 = value.toPrecision(valueLength - 1);
            return formattedValue_10;
        }
        var formattedValue_11 = value.toPrecision(4);
        return formattedValue_11;
    }
    if (integerValue.length === 4) {
        var formattedValue_12 = value.toPrecision(4);
        return formattedValue_12;
    }
    var formattedValue = Number.parseFloat(stringValue)
        .toExponential(4)
        .toUpperCase();
    return formattedValue;
};
var G = function (value) {
    var stringValue = value.toString();
    var valueLength = stringValue.length;
    var isInteger = Number.isInteger(value);
    var integerValue = Number.parseFloat(stringValue).toFixed();
    var integerLength = integerValue.length;
    if (isInteger) {
        if (valueLength < 16) {
            return stringValue;
        }
        var formattedValue_13 = Number.parseFloat(stringValue).toExponential();
        return formattedValue_13;
    }
    if (valueLength < 16) {
        return stringValue;
    }
    if (integerLength < 16) {
        return integerValue;
    }
    var formattedValue = Number.parseFloat(stringValue).toExponential();
    return formattedValue;
};
exports.getFormattedFloatingPoint = (0, cond_1.default)([
    [
        function (params) { return (0, isEqual_1.default)(params.plxFormat, '0'); },
        function (params) {
            var formattedValue = toFixedDecimalPlace(params.value, 0);
            return formattedValue;
        },
    ],
    [
        function (params) { return (0, isEqual_1.default)(params.plxFormat, '0.00'); },
        function (params) {
            var formattedValue = toFixedDecimalPlace(params.value, 2);
            return formattedValue;
        },
    ],
    [
        function (params) {
            return (0, isEqual_1.default)(params.plxFormat, '0.00%');
        },
        function (params) {
            var formattedValue = allPurposeFormatter(params.value, 'percent', 2, 2, false);
            return formattedValue;
        },
    ],
    [
        function (params) {
            return (0, isEqual_1.default)(params.plxFormat, '0.000000');
        },
        function (params) {
            var formattedValue = allPurposeFormatter(params.value, 'decimal', 6, 6, false);
            return formattedValue;
        },
    ],
    [
        function (params) {
            return (0, isEqual_1.default)(params.plxFormat, '#,##0.00');
        },
        function (params) {
            var formattedValue = allPurposeFormatter(params.value, 'decimal', 2, 2, true);
            return formattedValue;
        },
    ],
    [
        function (params) { return (0, isEqual_1.default)(params.plxFormat, 'C'); },
        function (params) {
            var formattedValue = currencyFormatter(params.value);
            return formattedValue;
        },
    ],
    [
        function (params) { return (0, isEqual_1.default)(params.plxFormat, 'C2'); },
        function (params) {
            var formattedValue = currencyFormatter(params.value);
            return formattedValue;
        },
    ],
    [
        function (params) { return (0, isEqual_1.default)(params.plxFormat, 'E'); },
        function (params) {
            var formattedValue = Number.parseFloat(params.value.toString())
                .toExponential(6)
                .toUpperCase();
            return formattedValue;
        },
    ],
    [
        function (params) { return (0, isEqual_1.default)(params.plxFormat, 'E4'); },
        function (params) {
            var formattedValue = Number.parseFloat(params.value.toString())
                .toExponential(4)
                .toUpperCase();
            return formattedValue;
        },
    ],
    [
        function (params) { return (0, isEqual_1.default)(params.plxFormat, 'F'); },
        function (params) {
            var formattedValue = allPurposeFormatter(params.value, 'decimal', 2, 2, true);
            return formattedValue;
        },
    ],
    [
        function (params) { return (0, isEqual_1.default)(params.plxFormat, 'F3'); },
        function (params) {
            var formattedValue = allPurposeFormatter(params.value, 'decimal', 3, 3, true);
            return formattedValue;
        },
    ],
    [
        function (params) { return (0, isEqual_1.default)(params.plxFormat, 'G'); },
        function (params) {
            var formattedValue = G(params.value);
            return formattedValue;
        },
    ],
    [
        function (params) { return (0, isEqual_1.default)(params.plxFormat, 'G4'); },
        function (params) {
            var formattedValue = G4(params.value);
            return formattedValue;
        },
    ],
    [
        function (params) { return (0, isEqual_1.default)(params.plxFormat, 'N'); },
        function (params) {
            var formattedValue = toFixedDecimalPlace(params.value, 2);
            return formattedValue;
        },
    ],
    [
        function (params) { return (0, isEqual_1.default)(params.plxFormat, 'N5'); },
        function (params) {
            var formattedValue = toFixedDecimalPlace(params.value, 5);
            return formattedValue;
        },
    ],
    [
        function (params) { return (0, isEqual_1.default)(params.plxFormat, 'P'); },
        function (params) {
            var formattedValue = allPurposeFormatter(params.value, 'percent', 2, 2, true);
            return formattedValue;
        },
    ],
    [
        function (params) { return (0, isEqual_1.default)(params.plxFormat, 'P1'); },
        function (params) {
            var formattedValue = allPurposeFormatter(params.value, 'percent', 1, 1, true);
            return formattedValue;
        },
    ],
    [
        function (params) { return (0, isEqual_1.default)(params.plxFormat, 'v4'); },
        function (params) {
            var formattedValue = allPurposeFormatter(params.value, 'decimal', 0, 0, true);
            return formattedValue;
        },
    ],
    [
        function (params) { return (0, isEqual_1.default)(params.plxFormat, 'V4'); },
        function (params) {
            var formattedValue = allPurposeFormatter(params.value, 'decimal', 0, 0, true);
            return formattedValue;
        },
    ],
    [
        function (params) { return (0, isEqual_1.default)(params.plxFormat, 'w12'); },
        function (params) {
            var formattedValue = w12LeadingZeros(params.value);
            return formattedValue;
        },
    ],
    [
        function (params) { return (0, isEqual_1.default)(params.plxFormat, 'W12'); },
        function (params) {
            var formattedValue = w12NoZeros(params.value);
            return formattedValue;
        },
    ],
    [
        stubTrue_1.default,
        function (params) {
            var formattedValue = toFixedDecimalPlace(params.value, 2);
            return formattedValue;
        },
    ],
]);
